import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { WIZARD_COLORS } from '../../../components/FormComponents/dynamicForm';
var ApplicationInfoBanner = function (_a) {
    var icon = _a.icon, title = _a.title, message = _a.message, _b = _a.isEmphasised, isEmphasised = _b === void 0 ? false : _b;
    return (React.createElement(Box, { role: "note", sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1.25,
            padding: '10px 14px',
            marginBottom: 2,
            borderRadius: '8px',
            backgroundColor: WIZARD_COLORS.highlight,
            border: isEmphasised ? '1px solid #B9D4FB' : 'none',
        } },
        React.createElement(Box, { "aria-hidden": true, sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                width: 28,
                height: 28,
                borderRadius: '8px',
                backgroundColor: isEmphasised ? WIZARD_COLORS.brand : WIZARD_COLORS.ink,
                color: WIZARD_COLORS.surface,
                '& svg': { fontSize: 17 },
            } }, icon),
        React.createElement(Typography, { sx: { fontSize: 13, color: WIZARD_COLORS.ink } },
            React.createElement(Box, { component: "span", sx: { fontWeight: 700 } }, title),
            ' ',
            message)));
};
export default React.memo(ApplicationInfoBanner);
